import EventEmitter from 'eventemitter3';
import AppController from '../controllers/AppController';

export default class AbstractComponent extends EventEmitter {
    constructor(el) {
        super();
        this.$el = el;
        this.$classname = '';

        // Checking abstract class instantiation
        if (this.constructor === AbstractComponent) {
            throw new TypeError('Abstract class "AbstractComponent" cannot be instantiated directly.');
        }

        // Checking abstract methods
        if (this.destroy === undefined) {
            throw new TypeError('Classes extending the "AbstractComponent" abstract class need to implement all required methods.');
        }

        // Default fields
        this.app = AppController.getInstance();
    }

    getClassname(suffix) {
        return this.classname + suffix;
    }

    getSelector(suffix) {
        return '.' + this.getClassname(suffix);
    }

    // /** To implement */
    // abstract destroy() {}
}
